module.exports = __webpack_public_path__ + "static/media/pastortroy.9cb096bf.jpg";